<script>
  import fetchNode from "../helpers/FetchNode.js";
  import { onMount } from 'svelte';
  import standardizeDate from "../helpers/standardizeDate.js";
  import { DateTime } from 'luxon';

  export let dateRange;
  export let user;
  export let propertiesListRequest;
  export let propertiesListView;
  export let listViewPage;
  export let emptyArray;

  let listViewLeft;
  let tableFullWidth;
  let sortBy = {col: "id", ascending: true};
  let dateHeader=-1;
  $: dateRange, cleanArray();

  propertiesListRequest =
      fetchNode('propertylistview',{
        user: user.airbetterRoleId ? "staff" : user.accountRole,
        start: standardizeDate(dateRange.start),
        end: standardizeDate(dateRange.end),
        page: 1,
      })

      .then(r=>
        propertiesListView = r
      );

  function cleanArray(){
    propertiesListRequest = fetchNode('propertylistview',{
        user: user.airbetterRoleId ? "staff" : user.accountRole,
        start: standardizeDate(dateRange.start),
        end: standardizeDate(dateRange.end),
        page: 1,
      })
      .then(r=>
        propertiesListView = r
      );
    listViewPage = 1;
  }

  function fetchData(){
    listViewPage += 1;
    if(emptyArray == 0){
      fetchNode('propertylistview',{
        user: user.airbetterRoleId ? "staff" : user.accountRole,
        start: standardizeDate(dateRange.start),
        end: standardizeDate(dateRange.end),
        page: listViewPage,
      }).then(r=>{
          if(r.length > 0){
            if(propertiesListRequest.length > 0){
              propertiesListRequest = propertiesListRequest.concat(r).sort(
                (A,B)=>{
                  if(A.dateFrom && A.dateTo && B.dateFrom && B.dateTo){
                    if(A.type == "Checkin" && B.type == "Checkin"){
                      return 0;
                    }else if(A.type == "Checkin" && B.type == "Checkout"){
                      let substract = new Date(A.dateFrom).getTime() - new Date(B.dateTo).getTime();
                      if(substract == 0){
                        return -1;
                      }
                      return substract;
                    }else if(A.type == "Checkout" && B.type == "Checkout"){
                      return 0;
                    }else if(A.type == "Checkout" && B.type == "Checkin"){
                      let substract = new Date(A.dateTo).getTime() - new Date(B.dateFrom).getTime();
                      if(substract == 0){
                        return 1;
                      }
                      return substract;
                    }
                  }else{
                    console.error("dateTo or dateFrom aren't defined on a booking, this is needed for sorting correctly");
                  }
                }
              );
              propertiesListView = propertiesListRequest;
            }else{
              propertiesListRequest = propertiesListView.concat(r).sort(
                (A,B)=>{
                if(A.dateFrom && A.dateTo && B.dateFrom && B.dateTo){
                    if(A.type == "Checkin" && B.type == "Checkin"){
                      return 0;
                    }else if(A.type == "Checkin" && B.type == "Checkout"){
                      let substract = new Date(A.dateFrom).getTime() - new Date(B.dateTo).getTime();
                      if(substract == 0){
                        return -1;
                      }
                      return substract;
                    }else if(A.type == "Checkout" && B.type == "Checkout"){
                      return 0;
                    }else if(A.type == "Checkout" && B.type == "Checkin"){
                      let substract = new Date(A.dateTo).getTime() - new Date(B.dateFrom).getTime();
                      if(substract == 0){
                        return 1;
                      }
                      return substract;
                    }
                  }else{
                    console.error("dateTo or dateFrom aren't defined on a booking, this is needed for sorting correctly");
                  }
                }
              );
              propertiesListView = propertiesListRequest;
            }
          }else{
            emptyArray = 1;
            listViewPage = 1;
          }
        }
      );
    }
  }

  function findPosY(e) {
    var top = 0;
    if (e.offsetParent && typeof (e.offsetParent) != 'undefined') {
      while (e.offsetParent) {
        top += e.offsetTop;
        e = e.offsetParent;
      }
      top += e.offsetTop;
    }
    else if (e.y){
      top += e.y;
    }
    return top;
  }

  function headers(){
    try {
      listViewLeft = document.getElementById('list-view').scrollLeft;
      tableFullWidth = document.getElementById('table').offsetWidth;
  		var header = document.getElementById('columns-name');
  		if(dateHeader<0){
        dateHeader=findPosY(header);
      }

  		if(window.pageYOffset+100>dateHeader){
  			header.style.position='absolute';
  			header.style.zIndex='5';
  			header.style.top=window.pageYOffset+"px";
        header.style.overflow="hidden";
        header.style.left=-listViewLeft+30+"px";
        header.style.width=tableFullWidth+"px";
        header.style.display="inline-table";
  		} else {
  			header.style.position='relative';
  			header.style.zIndex='auto';
        header.style.top=0;
        header.style.left=0;
        header.style.display="table-row";
  		}
  	} catch (ex){
  		console.log(ex,"not using on scroll")
  	}
  };

  window.onmousemove = headers;
  window.onmouseup = headers;
  window.onwheel = headers;
  window.onkeyup = headers;
  window.onscroll = headers;

  $: sort = (column) => {
    if(column.split(".")[1]){
      let secondLevel =	column.split(".")[1];
      let columnName =	column.split(".")[0];
  	  if (sortBy.col == secondLevel) {
  	  	sortBy.ascending = !sortBy.ascending
  	  } else {
  	  	sortBy.col = secondLevel
  	  	sortBy.ascending = true
  	  }

  	  // Modifier to sorting function for ascending or descending
  	  let sortModifier = (sortBy.ascending) ? 1 : -1;

  	  let sort = (a, b) =>
        (!a[columnName] || !b[columnName])
        ? -1
        : (a[columnName][secondLevel] < b[columnName][secondLevel])
  	  	? -1 * sortModifier
  	  	: (a[columnName][secondLevel] > b[columnName][secondLevel])
  	  	? 1 * sortModifier
  	  	: 0;

      propertiesListRequest = propertiesListView.sort(sort);
    }else{
      if (sortBy.col == column) {
        sortBy.ascending = !sortBy.ascending
      } else {
        sortBy.col = column
        sortBy.ascending = true
      }

      // Modifier to sorting function for ascending or descending
      let sortModifier = (sortBy.ascending) ? 1 : -1;

      let sort = (a, b) =>
        (a[column] < b[column])
        ? -1
        : (a[column] > b[column])
        ? 1 * sortModifier
        : 0;

      propertiesListRequest = propertiesListView.sort(sort);
    }
  }
</script>
<div id="table">
  <table >
  {#if user.accountRole.toLowerCase() == "cleaner"}
    <tr class="columns-name" id="columns-name">
      <th class="type" on:click={sort("type")}>CI/CO</th>
      <th class="booking" on:click={sort("id")}>BOOKING</th>
      <th class="pname" on:click={sort("airbetterId.name")}>PROPERTY NAME</th>
      <th class="aname" on:click={sort("airbetterId.airbetterName")}>AIRBETTER NAME</th>
      <th class="gfname" on:click={sort("guestFirstName")}>GUEST FIRST NAME</th>
      <th class="glname" on:click={sort("guestLastName")}>GUEST SURNAME</th>
      <th class="gnumber" on:click={sort("numberOfGuests")}>NUMBER OF GUESTS</th>
      <th class="checkin" on:click={sort("dateFrom")}>CHECK IN</th>
      <th class="checkout" on:click={sort("dateTo")}>CHECK OUT</th>
      <th class="nights" on:click={sort("nights")}># NIGHTS</th>
      <th class="channelId" on:click={sort("channelId.companyName")}>CHANNEL</th>
      <th class="checkinComments" on:click={sort("airbetterCheckout")}>CHECKIN COMMENTS</th>
      <th class="checkoutComments" on:click={sort("internalComments")}>CHECKOUT COMMENTS</th>
    </tr>
    {#await propertiesListRequest then propertiesList1}
     console.log("ho");
      {#if propertiesList1.length > 0}
        {#each propertiesList1 as propertiesList}
          <tr>
            <td class="type">{propertiesList.type}</td>
            <td class="booking">{propertiesList.id}</td>
            <td class="pname">{propertiesList.airbetterId.name}</td>
            {#if propertiesList.airbetterId.airbetterName}
              <td class="aname">
                {propertiesList.airbetterId.airbetterName}
              </td>
            {:else}
              <td class="aname">
                -
              </td>
            {/if}
            <td class="gfname">{propertiesList.guestFirstName}</td>
            <td class="glname">{propertiesList.guestLastName}</td>
            <td class="glname"> {propertiesList.numberOfGuests > propertiesList.airbetterId.standardGuests ? propertiesList.numberOfGuests :propertiesList.airbetterId.standardGuests}  </td>

            {#if propertiesList.type === "Checkin"}
              <td class="checkin" style="font-weight: 600">
                {DateTime.fromISO(propertiesList.dateFrom).toLocaleString()}
              </td>
            {:else}
              <td class="checkin">
                {DateTime.fromISO(propertiesList.dateFrom).toLocaleString()}
              </td>
            {/if}
            {#if propertiesList.type === "Checkout"}
              <td class="checkout" style="font-weight: 600">
                {DateTime.fromISO(propertiesList.dateTo).toLocaleString()}
              </td>
            {:else}
              <td class="checkout">
                {DateTime.fromISO(propertiesList.dateTo).toLocaleString()}
              </td>
            {/if}
            <td class="nights">{propertiesList.nights}</td>
            <td class="channelId">
              {#if propertiesList.channelId.companyName !== null}
                {propertiesList.channelId.companyName}
              {:else}
                -
              {/if}
            </td>
            <td class="checkinComments">
              {#if propertiesList.airbetterCheckin !== null}
                {propertiesList.airbetterCheckin}
              {:else}
                -
              {/if}
            </td>
            <td class="checkoutComments">
              {#if propertiesList.airbetterCheckout !== null}
                {propertiesList.airbetterCheckout}
              {:else}
                -
              {/if}
            </td>
          </tr>
        {/each}
      {:else}
        <tr>
          <td class="no-matches" colspan="9">No matches</td>
        </tr>
      {/if}
    {/await}
  {:else if user.airbetterRoleId == 1}
    <tr class="columns-name" id="columns-name">
      <th class="type" on:click={sort("type")}>CI/CO</th>
      <th class="booking" on:click={sort("id")}>BOOKING</th>
      <th class="transfer" on:click={sort("originalReservationId")}>TRANSFER</th>
      <th class="pname" on:click={sort("airbetterId.name")}>PROPERTY NAME</th>
      <th class="aname" on:click={sort("airbetterId.airbetterName")}>AIRBETTER NAME</th>
      <th class="gfname" on:click={sort("guestFirstName")}>GUEST FIRST NAME</th>
      <th class="glname" on:click={sort("guestLastName")}>GUEST SURNAME</th>
      <th class="gnumber" on:click={sort("numberOfGuests")}>NUMBER OF GUESTS</th>
      <th class="checkin" on:click={sort("dateFrom")}>CHECK IN</th>
      <th class="checkout" on:click={sort("dateTo")}>CHECK OUT</th>
      <th class="nights" on:click={sort("nights")}># NIGHTS</th>
      <th class="channelId" on:click={sort("channelId.companyName")}>CHANNEL</th>
      <th class="damount" on:click={sort("securityDeposit[0].amount")}>DEPOSIT AMOUNT</th>
      <th class="dcurrency" on:click={sort("securityDeposit[0].currencyCollected")}>CURRENCY</th>
      <th class="dcollection" on:click={sort("securityDeposit[0].amountCollected")}>DEPOSIT STATUS</th>
      <th class="sellrate" on:click={sort("sellRate")}>SELL RATE</th>
      <th class="pcurrency" on:click={sort("airbetterId.currency")}>CURRENCY</th>
      <th class="checkinComments" on:click={sort("airbetterCheckin")}>CHECKIN COMMENTS</th>
      <th class="checkoutComments" on:click={sort("airbetterCheckout")}>CHECKOUT COMMENTS</th>
      <th class="internalComments" on:click={sort("internalComments")}>INTERNAL COMMENTS</th>
    </tr>
    {#await propertiesListRequest then propertiesList1}
      {#if propertiesList1.length > 0}
        {#each propertiesList1 as propertiesList}
          <tr>
            <td class="type">{propertiesList.type}</td>
            <td class="booking">{propertiesList.id}</td>
            <td class="transfer">
              {#if propertiesList[0]}
                {propertiesList[0].airbetterId.airbetterName}
              {:else}
                -
              {/if}
            </td>
            <td class="pname">{propertiesList.airbetterId.name}</td>
            {#if propertiesList.airbetterId.airbetterName}
              <td class="aname">
                {propertiesList.airbetterId.airbetterName}
              </td>
            {:else}
              <td class="aname">
                -
              </td>
            {/if}
            <td class="gfname">{propertiesList.guestFirstName}</td>
            <td class="glname">{propertiesList.guestLastName}</td>
            <td class="gnumber"> {propertiesList.numberOfGuests > propertiesList.airbetterId.standardGuests ? propertiesList.numberOfGuests :propertiesList.airbetterId.standardGuests}  </td>

            {#if propertiesList.type === "Checkin"}
              <td class="checkin" style="font-weight: 600">
                {DateTime.fromISO(propertiesList.dateFrom).toLocaleString()}
              </td>
            {:else}
              <td class="checkin">
                {DateTime.fromISO(propertiesList.dateFrom).toLocaleString()}
              </td>
            {/if}
            {#if propertiesList.type === "Checkout"}
              <td class="checkout" style="font-weight: 600">
                {DateTime.fromISO(propertiesList.dateTo).toLocaleString()}
              </td>
            {:else}
              <td class="checkout">
                {DateTime.fromISO(propertiesList.dateTo).toLocaleString()}
              </td>
            {/if}
            <td class="nights">{propertiesList.nights}</td>
            <td class="channelId">
              {#if propertiesList.channelId.companyName !== null}
                {propertiesList.channelId.companyName}
              {:else}
                -
              {/if}
            </td>
            <td class="damount">
              {#if propertiesList.securityDeposit[0]}
                {propertiesList.securityDeposit[0].amount}
              {:else}
                -
              {/if}
            </td>
            <td class="dcurrency">
              {#if propertiesList.securityDeposit[0]}
                {#if propertiesList.securityDeposit[0].currencyCollected !== null}
                  {propertiesList.securityDeposit[0].currencyCollected}
                {:else}
                  -
                {/if}
              {:else}
                -
              {/if}
            </td>
            <td class="dcollection">
              {#if propertiesList.securityDeposit[0]}
                {#if propertiesList.securityDeposit[0].amountCollected !== null}
                  Collected
                {:else}
                  Pending
                {/if}
              {:else}
                -
              {/if}
            </td>
            <td class="sellrate">{propertiesList.sellRate}</td>
            <td class="pcurrency">{propertiesList.airbetterId.currency}</td>
            <td class="checkinComments">
              {#if propertiesList.airbetterCheckin !== null}
                {propertiesList.airbetterCheckin}
              {:else}
                -
              {/if}
            </td>
            <td class="checkoutComments">
              {#if propertiesList.airbetterCheckout !== null}
                {propertiesList.airbetterCheckout}
              {:else}
                -
              {/if}
            </td>
            <td class="internalComments">
              {#if propertiesList.internalComments !== null}
                {propertiesList.internalComments}
              {:else}
                -
              {/if}
            </td>
          </tr>
        {/each}
      {:else}
        <tr>
          <td class="no-matches" colspan="18">No matches</td>
        </tr>
      {/if}
    {/await}
  {:else}
    <tr class="columns-name" id="columns-name">
      <th class="type" on:click={sort("type")}>CI/CO</th>
      <th class="booking" on:click={sort("id")}>BOOKING</th>
      <!--
      <th class="transfer" on:click={sort("originalReservationId")}>TRANSFER</th>
      <th class="pname" on:click={sort("airbetterId.name")}>PROPERTY NAME</th>
      -->
      <th class="aname" on:click={sort("airbetterId.airbetterName")}>AIRBETTER NAME</th>
      <th class="gfname" on:click={sort("guestFirstName")}>GUEST FIRST NAME</th>
      <th class="glname" on:click={sort("guestLastName")}>GUEST SURNAME</th>
      <th class="gnumber" on:click={sort("numberOfGuests")}>NUMBER OF GUESTS</th>
      <th class="checkin" on:click={sort("dateFrom")}>CHECK IN</th>
      <th class="checkout" on:click={sort("dateTo")}>CHECK OUT</th>
      <th class="nights" on:click={sort("nights")}># NIGHTS</th>
      <th class="channelId" on:click={sort("channelId.companyName")}>CHANNEL</th>
      <th class="damount" on:click={sort("securityDeposit[0].amount")}>DEPOSIT AMOUNT</th>
      <th class="dcurrency" on:click={sort("securityDeposit[0].currencyCollected")}>CURRENCY</th>
      <th class="dcollection" on:click={sort("securityDeposit[0].amountCollected")}>DEPOSIT STATUS</th>
      <!--
      <th class="sellrate" on:click={sort("sellRate")}>SELL RATE</th>
      -->
      <th class="pcurrency" on:click={sort("airbetterId.currency")}>CURRENCY</th>
      <th class="checkinComments" on:click={sort("airbetterCheckin")}>CHECKIN COMMENTS</th>
      <th class="checkoutComments" on:click={sort("airbetterCheckout")}>CHECKOUT COMMENTS</th>
    </tr>
    {#await propertiesListRequest then propertiesList1}
      {#if propertiesList1.length > 0}
        {#each propertiesList1 as propertiesList}
          <tr>
            <td class="type">{propertiesList.type}</td>
            <td class="booking">{propertiesList.id}</td>
            <!--
            <td class="transfer">
              {#if propertiesList.originalReservationId}
                {propertiesList.originalReservationId}
              {:else}
                -
              {/if}
            </td>
            <td class="pname">{propertiesList.airbetterId.name}</td>
            -->
            {#if propertiesList.airbetterId.airbetterName}
              <td class="aname">
                {propertiesList.airbetterId.airbetterName}
              </td>
            {:else}
              <td class="aname">
                -
              </td>
            {/if}
            <td class="gfname">{propertiesList.guestFirstName}</td>
            <td class="glname">{propertiesList.guestLastName}</td>
            <td class="glname"> {propertiesList.numberOfGuests > propertiesList.airbetterId.standardGuests ? propertiesList.numberOfGuests :propertiesList.airbetterId.standardGuests}  </td>

            {#if propertiesList.type === "Checkin"}
              <td class="checkin" style="font-weight: 600">
                {DateTime.fromISO(propertiesList.dateFrom).toLocaleString()}
              </td>
            {:else}
              <td class="checkin">
                {DateTime.fromISO(propertiesList.dateFrom).toLocaleString()}
              </td>
            {/if}
            {#if propertiesList.type === "Checkout"}
              <td class="checkout" style="font-weight: 600">
                {DateTime.fromISO(propertiesList.dateTo).toLocaleString()}
              </td>
            {:else}
              <td class="checkout">
                {DateTime.fromISO(propertiesList.dateTo).toLocaleString()}
              </td>
            {/if}
            <td class="nights">{propertiesList.nights}</td>
            <td class="channelId">
              {#if propertiesList.channelId.companyName !== null}
                {propertiesList.channelId.companyName}
              {:else}
                -
              {/if}
            </td>
            <td class="damount">
              {#if propertiesList.securityDeposit[0]}
                {propertiesList.securityDeposit[0].amount}
              {:else}
                -
              {/if}
            </td>
            <td class="dcurrency">
              {#if propertiesList.securityDeposit[0]}
                {#if propertiesList.securityDeposit[0].currencyCollected !== null}
                  {propertiesList.securityDeposit[0].currencyCollected}
                {:else}
                  -
                {/if}
              {:else}
                -
              {/if}
            </td>
            <td class="dcollection">
              {#if propertiesList.securityDeposit[0]}
                {#if propertiesList.securityDeposit[0].amountCollected !== null}
                  Collected
                {:else}
                  Pending
                {/if}
              {:else}
                -
              {/if}
            </td>
            <!--
            <td class="sellrate">{propertiesList.sellRate}</td>
            -->
            <td class="pcurrency">{propertiesList.airbetterId.currency}</td>
            <td class="checkinComments">
              {#if propertiesList.airbetterCheckin !== null}
                {propertiesList.airbetterCheckin}
              {:else}
                -
              {/if}
            </td>
            <td class="checkoutComments">
              {#if propertiesList.airbetterCheckout !== null}
                {propertiesList.airbetterCheckout}
              {:else}
                -
              {/if}
            </td>
          </tr>
        {/each}
      {:else}
        <tr>
          <td class="no-matches" colspan="18">No matches</td>
        </tr>
      {/if}
    {/await}
  {/if}
  </table>
</div>
{#if emptyArray==0}
  <div class="button-load-more-container">
    <button on:click={fetchData} class="button-load-more">Load more</button>
  </div>
{/if}
<style>
.no-matches{
  font-size: 1rem;
  padding: 1rem;
}
table{
  border-spacing:0;
  border-collapse: collapse;
  font-size: .8rem;
  width: 100%;
}
table tr th td{
  padding: 0 10px;

}
th{
  background-color: #EF4064;
  color: white;
  border: 1px solid #ddd;
}
td:first-child{
  color: #5FB3D5;
  font-weight: bold;
}
tr:nth-child(odd){
  background-color: #F4F3EF;
}
tr:nth-child(even){
  background-color: white;
}
td, th{
  padding: 0;
  border: 1px solid #ddd;
  padding: 5px 10px;
  text-align: center;
  vertical-align: middle;
}
.columns-name{
  user-select: none;
  cursor: pointer;
  overflow: auto;
}

.type,
.booking,
.gfname,
.glname,
.gnumber,
.checkin,
.checkout,
.nights,
.damount,
.dcurrency,
.dcollection,
.sellrate,
.pcurrency,
.channelId{
  min-width: 85px;
  max-width: 85px;
}
td.gfname,
td.glname,
td.gnumber,
td.transfer,
td.aname{
  word-break: break-all;
}
.pname{
  min-width: 150px;
  max-width: 150px;
}
.aname,
.transfer{
  min-width: 150px;
  max-width: 150px;
}
.checkinComments,
.checkoutComments,
.internalComments{
  min-width: 85px;
  max-width: 85px;
}
.button-load-more-container{
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.button-load-more{
  padding: .5rem 1rem;
  background-color: #EF4064;
  color: white;
  font-weight: 600;
  border-radius: 5px;
  margin: 1rem 0;
}
</style>
